import { InjectionToken, Inject, Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'projects/cv-builder/src/environments/environment';

export const APP_CONFIG_LOCATION = new InjectionToken<string>(
  'The location of the applicationconfiguration file',
  {
    factory: () => '/assets/environment.json?v=2',
  }
);

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private httpClient: HttpClient;

  private readonly envSettings$ = new BehaviorSubject<any>(environment);

  set environment(value) {
    this.envSettings$.next(value);
  }

  get environment() {
    return this.envSettings$.value;
  }

  get baseApiUrl(): string {
    return `${this.environment?.settings?.apiBaseUrl}/api/v2.1`;
  }

  get apimSubscriptionKey(): string {
    return this.environment?.settings?.apimSubscriptionKey;
  }

  constructor(
    @Inject(APP_CONFIG_LOCATION)
    private configLocation: string,
    handler: HttpBackend
  ) {
    this.httpClient = new HttpClient(handler);
  }

  loadConfig() {
    return this.httpClient
      .get(this.configLocation)
      .pipe(
        map((data: string) => {
          const parseJson = JSON.parse(JSON.stringify(data));
          return (this.environment = {
            ...this.environment,
            settings: parseJson,
          });
        })
      )
      .toPromise();
  }
}
